export interface Region {
  id: string;
  nom: string;
  centre: {
    lat: number;
    lng: number;
  };
  villes: string[];
  description: string;
  image: string;
}

export const regions: Region[] = [
  {
    id: "bas-saint-laurent",
    nom: "Bas-Saint-Laurent",
    centre: { lat: 48.3556, lng: -68.5323 },
    villes: ["Rimouski", "Rivière-du-Loup"],
    description: "Des couchers de soleil légendaires et une tradition maritime vivante sur la rive sud.",
    image: "https://images.unsplash.com/photo-1628117761795-2f8021c33f2d?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "saguenay",
    nom: "Saguenay–Lac-Saint-Jean",
    centre: { lat: 48.4285, lng: -71.07 },
    villes: ["Saguenay", "Alma", "Dolbeau-Mistassini"],
    description: "Le royaume du fjord majestueux et de l'immense mer intérieure qu'est le Lac-Saint-Jean.",
    image: "https://images.unsplash.com/photo-1599335661131-f925b6823c34?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "capitale-nationale",
    nom: "Capitale-Nationale",
    centre: { lat: 46.8139, lng: -71.208 },
    villes: ["Québec", "Charlevoix", "Portneuf"],
    description: "Le cœur historique du Québec, berceau de la civilisation française en Amérique du Nord.",
    image: "https://images.unsplash.com/photo-1570554869614-234208221805?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "mauricie",
    nom: "Mauricie",
    centre: { lat: 46.5562, lng: -72.7508 },
    villes: ["Trois-Rivières", "Shawinigan"],
    description: "Une région de forêts denses et de rivières, reliant les deux grandes métropoles.",
    image: "https://images.unsplash.com/photo-1629851722822-54070768c7e4?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "estrie",
    nom: "Cantons-de-l'Est (Estrie)",
    centre: { lat: 45.4033, lng: -71.889 },
    villes: ["Sherbrooke", "Magog", "Sutton"],
    description: "Charme anglo-saxon, vignobles réputés et montagnes parfaites pour le plein air.",
    image: "https://images.unsplash.com/photo-1663004066708-8e622b724493?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "montreal",
    nom: "Montréal",
    centre: { lat: 45.5017, lng: -73.5673 },
    villes: ["Montréal", "Westmount"],
    description: "Métropole vibrante et cosmopolite, reconnue mondialement pour sa culture et ses festivals.",
    image: "https://images.unsplash.com/photo-1519178173668-2ef94c5363b6?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "outaouais",
    nom: "Outaouais",
    centre: { lat: 45.4275, lng: -75.7068 },
    villes: ["Gatineau", "Maniwaki"],
    description: "Porte d'entrée de l'ouest, riche en musées nationaux et en parcs naturels.",
    image: "https://images.unsplash.com/photo-1606859341496-e24391672323?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "abitibi-temiscamingue",
    nom: "Abitibi-Témiscamingue",
    centre: { lat: 48.2319, lng: -79.0264 },
    villes: ["Rouyn-Noranda", "Val-d'Or"],
    description: "Une terre de pionniers aux forêts infinies et aux lacs sauvages.",
    image: "https://images.unsplash.com/photo-1447752875253-b756c946e9eb?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "cote-nord",
    nom: "Côte-Nord",
    centre: { lat: 50.2096, lng: -66.39 },
    villes: ["Sept-Îles", "Baie-Comeau", "Tadoussac"],
    description: "Le pays des baleines, de la taïga et des grands barrages hydroélectriques.",
    image: "https://images.unsplash.com/photo-1589405858864-2d50c733f6b9?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "nord-du-quebec",
    nom: "Nord-du-Québec",
    centre: { lat: 53.0, lng: -77.0 },
    villes: ["Chibougamau", "Lebel-sur-Quévillon"],
    description: "L'immensité du territoire, domaine de la toundra et des aurores boréales.",
    image: "https://images.unsplash.com/photo-1579033461380-adb47c3eb938?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "gaspesie",
    nom: "Gaspésie–Îles-de-la-Madeleine",
    centre: { lat: 48.3644, lng: -64.3352 },
    villes: ["Gaspé", "Percé", "Matane"],
    description: "Mer, montagnes et plages de sable rouge : une péninsule aux paysages de carte postale.",
    image: "https://images.unsplash.com/photo-1628117761795-2f8021c33f2d?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "chaudiere-appalaches",
    nom: "Chaudière-Appalaches",
    centre: { lat: 46.8048, lng: -71.1739 },
    villes: ["Lévis", "Saint-Georges"],
    description: "Rive sud de Québec, paysages champêtres et riche patrimoine seigneurial.",
    image: "https://images.unsplash.com/photo-1616428741366-02e071c40f5d?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "laval",
    nom: "Laval",
    centre: { lat: 45.5758, lng: -73.7531 },
    villes: ["Laval"],
    description: "Île dynamique voisine de Montréal, mêlant urbanité et zones agrotouristiques.",
    image: "https://images.unsplash.com/photo-1563203369-26f2e4a5ccf7?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "lanaudiere",
    nom: "Lanaudière",
    centre: { lat: 46.0355, lng: -73.4385 },
    villes: ["Joliette", "Terrebonne"],
    description: "Le maillage parfait entre la plaine agricole et le plateau laurentien.",
    image: "https://images.unsplash.com/photo-1502082553048-f009c37129b9?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "laurentides",
    nom: "Laurentides",
    centre: { lat: 46.1186, lng: -74.4704 },
    villes: ["Saint-Jérôme", "Mont-Tremblant"],
    description: "La destination de villégiature 4 saisons par excellence, parsemée de lacs et de stations de ski.",
    image: "https://images.unsplash.com/photo-1579782540510-92841445722f?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "monteregie",
    nom: "Montérégie",
    centre: { lat: 45.5417, lng: -73.2667 },
    villes: ["Longueuil", "Saint-Hyacinthe"],
    description: "Le garde-manger du Québec, célèbre pour ses vergers, ses cidreries et le Mont-Saint-Hilaire.",
    image: "https://images.unsplash.com/photo-1634839818451-876307455060?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "centre-du-quebec",
    nom: "Centre-du-Québec",
    centre: { lat: 46.0333, lng: -72.0833 },
    villes: ["Drummondville", "Victoriaville"],
    description: "Au sud du fleuve, une région accueillante reconnue pour la canneberge et l'érable.",
    image: "https://images.unsplash.com/photo-1616428741366-02e071c40f5d?q=80&w=1200&auto=format&fit=crop",
  },
];
